<script setup lang="ts">
const {
  root = true,
  parentItemKey = '',
  index = 0,
} = defineProps<{
  item: MenuItems;
  index: number;
  root: boolean;
  parentItemKey: string;
}>();

const route = useRoute();

const { layoutState, setActiveMenuItem, onMenuToggle } = useLayout();

interface MenuItems {
  label: string;
  icon?: string;
  to?: string;
  class?: string;
  target?: string;
  items?: MenuItems[];
}

const isActiveMenu = ref(false);
const itemKey = ref('');

watch(
  () => layoutState.activeMenuItem,
  (newVal) => {
    isActiveMenu.value = newVal === itemKey.value || newVal.startsWith(`${itemKey.value}-`);
  },
);

onBeforeMount(() => {
  itemKey.value = parentItemKey ? `${parentItemKey}-${index}` : String(index);
  const activeItem = layoutState.activeMenuItem;
  isActiveMenu.value = activeItem === itemKey.value || activeItem ? activeItem.startsWith(`${itemKey.value}-`) : false;
});

function checkActiveRoute(item: Partial<MenuItems>) {
  const routeTo = item.to?.split('/') || [];
  const routePath = route.path.split('/') || [];
  return routePath[1] === routeTo[1];
}

function itemClick(item: MenuItems) {
  // if (item.disabled) {
  //     event.preventDefault();
  //     return;
  // }

  if (item.to && (layoutState.staticMenuMobileActive || layoutState.overlayMenuActive)) {
    onMenuToggle();
  }

  // if (item.command) {
  //     item.command({ originalEvent: event, item: item });
  // }

  const foundItemKey = item.items ? (isActiveMenu.value ? parentItemKey : itemKey.value) : itemKey.value;
  setActiveMenuItem(foundItemKey);
}
</script>

<template>
  <li :class="{ 'layout-root-menuitem': root, 'active-menuitem': isActiveMenu }">
    <!-- <div v-if="root" class="layout-menuitem-root-text">
      {{ item.label }}
    </div> -->
    <a v-if="!item.to || item.items" :href="item.to" :class="item.class" :target="item.target" tabindex="0" @click="itemClick(item)">
      <i :class="item.icon" class="layout-menuitem-icon" />
      <span class="layout-menuitem-text">{{ item.label }}</span>
      <i v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler" />
    </a>
    <RouterLink v-if="item.to && !item.items" :class="[item.class, { 'active-route': checkActiveRoute(item) }]" tabindex="0" :to="item.to" @click="itemClick(item)">
      <i :class="item.icon" class="layout-menuitem-icon" />
      <span class="layout-menuitem-text">{{ item.label }}</span>
      <i v-if="item.items" class="pi pi-fw pi-angle-down layout-submenu-toggler" />
    </RouterLink>
    <Transition v-if="item.items" name="layout-submenu">
      <ul v-show="root ? true : isActiveMenu" class="layout-submenu">
        <AppMenuItem v-for="(child, i) in item.items" :key="i" :index="i" :item="child" :parent-item-key="itemKey" :root="false" />
      </ul>
    </Transition>
  </li>
</template>

<style lang="scss" scoped></style>
